(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (function () {
    if (window.__miLoadMoreBound) return;
    window.__miLoadMoreBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-mi-load-more-button]');
      if (!button) return;
      event.preventDefault();

      var wrapper = button.closest('[data-mi-load-more]');
      var sectionId = wrapper ? wrapper.getAttribute('data-section-id') : null;
      var grid = document.getElementById('product-grid');
      if (!sectionId || !grid) return;

      var url = new URL(button.href, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      button.classList.add('is-loading');

      fetch(url.toString())
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          var newWrapper = doc.querySelector('[data-mi-load-more]');
          if (newGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (item) {
              grid.appendChild(item);
            });
          }
          if (newWrapper && wrapper) {
            wrapper.replaceWith(newWrapper);
          } else if (wrapper) {
            wrapper.remove();
          }
          var pageUrl = new URL(button.href, window.location.origin);
          pageUrl.searchParams.delete('section_id');
          window.history.replaceState({}, '', pageUrl.toString());
        })
        .catch(function () {
          button.classList.remove('is-loading');
          window.location.href = button.href;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mi-back-to-top"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__miBackToTopBound) return;
    window.__miBackToTopBound = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-mi-back-to-top]');
      if (!button) return;
      event.preventDefault();
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      } catch (error) {
        window.scrollTo(0, 0);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
